<template>
  <div class>
    <v-alert
      v-model="alert"
      dismissible
      color="red"
      border="left"
      elevation="2"
      colored-border
      icon="mdi-alert"
    >
     {{mensaje}}
    </v-alert>
  </div>
</template>
<script>
  export default {
      name: 'mensajeCard',
    data () {
      return {
        alert: true,
      }
    },
    props:[
      'mensaje'
    ]

    
  }
</script>